import React, { useState } from "react";
import { Link } from "react-router-dom";
import ContactFormModal from '../common/ContactFormModal';
import { sendEvent } from "../../utils/gtag";

const ChatIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.745A9.863 9.863 0 013 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
    </svg>
);

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [activeMenu, setActiveMenu] = useState(null);
  const [mobileSubMenuOpen, setMobileSubMenuOpen] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  let timeout;

  const navLinks = [
    {
      name: "AI",
      path: "/ai-solutions",
      type: "default",
      submenu: [
        { title: "AI-Powered Chatbots", desc: "Develop intelligent chatbots for customer service, support, and engagement", path: "/ai-solutions/1" },
        { title: "AI Fraud Detection", desc: "Implement advanced AI models to detect and prevent fraudulent activities", path: "/ai-solutions/2" },
        { title: "AI Medical Diagnosis", desc: "Leverage AI for accurate and early medical diagnosis.", path: "/ai-solutions/3" },
        { title: "AI Recommendation Engine", desc: "Build personalized recommendation systems to boost sales and user satisfaction", path: "/ai-solutions/4" },
        { title: "CRM Dashboard with AI", desc: "Integrate AI into CRM dashboards for predictive analytics, lead scoring, and customer insights", path: "/ai-solutions/5" },
        { title: "E-commerce AI Solutions", desc: "Enhance e-commerce platforms with AI for dynamic workload", path: "/ai-solutions/6" },
      ],
    },
    {
      name: "Edutech",
      path: "/edutech",
      type: "default",
      submenu: [
        { title: "Custom LMS", desc: "Our Custom Learning Management Systems are tailored to your specific educational needs.", path: "/edutech/1" },
        { title: "Live Video Trainings", desc: "Engage your audience with our high-quality Live Video Training solutions.", path: "/edutech/2" },
        { title: "AI Integration", desc: "Revolutionize your educational offerings with our AI Integration services.", path: "/edutech/3" },
        { title: "Custom eLearning", desc: "We develop bespoke eLearning solutions that are designed to meet your specific learning objectives.", path: "/edutech/4" },
        { title: "Mobile Learning", desc: "Deliver learning anytime, anywhere with our Mobile Learning solutions.", path: "/edutech/5" },
        { title: "Microlearning", desc: "Our Microlearning solutions deliver bite-sized learning modules that are designed for maximum retention and engagement.", path: "/edutech/6" },
      ],
    },
    {
      name: "Services",
      path: "/services",
      type: "default",
      submenu: [
        { title: "Software Development", desc: "Innovative software solutions tailored to your business needs", path: "/services/7" },
        { title: "Web Development", desc: "Robust web apps crafted for performance & user engagement", path: "/services/8" },
        { title: "Mobile App Development", desc: "Custom mobile apps built for performance and reliability", path: "/services/9" },
        { title: "UI/UX Design", desc: "Intuitive designs focused on enhancing user interaction", path: "/services/10" },
        { title: "Full Cycle Product Development", desc: "End-to-end development from concept to launch", path: "/services/11" },
        { title: "SaaS Product Development", desc: "Scalable SaaS solutions for modern business challenges", path: "/services/12" },
      ],
    },
    // {
    //   name: "Technology",
    //   path: "#",
    //   type: "categories",
    //   submenu: [
    //     { heading: "Frontend", items: ["Angular JS", "React JS", "Vue JS", "Javascript", "Tailwind CSS"] },
    //     { heading: "Backend", items: ["Node.js", ".NET Core", "Python", "Laravel", "PHP"] },
    //     { heading: "Mobile", items: ["iOS", "Android", "Flutter", "React Native"] },
    //     { heading: "Cloud", items: ["AWS", "Google Cloud", "Azure"] },
    //     { heading: "Trending", items: ["IoT", "Blockchain"] },
    //   ],
    // },
    {
      name: "Case Studies",
      path: "/case-studies",
      type: "default",
    },
    // {
    //   name: "Work",
    //   path: "#",
    //   type: "default",
    //   submenu: [
    //     { title: "Budget", desc: "All Budget ranges from <$10k to >$100k", path: "/work/budget" },
    //   ],
    // },
    { name: "Company", path: "/company", type: "default" },
    { name: "Blog", path: "/blog", type: "default" },
  ];

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white shadow-md">
      <div className="container mx-auto px-4 md:px-6 py-0 md:py-2">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
            <img src="/TechVelly.png" alt="TechVelly Logo" className="w-16 h-16 md:w-16 md:h-16 object-contain" />
            <span className="text-2xl md:text-2xl font-medium tracking-wider bg-gradient-to-r from-[#35a89d] to-[#264864] bg-clip-text text-transparent md:text-xl lg:text-2xl">
              TechVelly
            </span>
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center md:space-x-4 lg:space-x-6 relative">
            {navLinks.map((item) => (
              <div
                key={item.name}
                className="relative"
                onMouseEnter={() => {
                  clearTimeout(timeout);
                  setActiveMenu(item);
                }}
                onMouseLeave={() => {
                  timeout = setTimeout(() => setActiveMenu(null), 150);
                }}
              >
                <Link
                    to={item.path}
                    onClick={() => item.name === 'Case Studies' && sendEvent('view_case_studies_click')}
                    className="text-[#264864] hover:text-[#35a89d] transition-all duration-300 font-normal md:text-xs lg:text-base relative"
                  >
                    {item.name}
                    <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-[#35a89d] to-[#264864] transition-all duration-300 group-hover:w-full"></span>
                  </Link>
              </div>
            ))}

            {/* Contact Button */}
            <button
              onClick={() => { sendEvent('contact_us_click', { source: 'header' }); setIsModalOpen(true); }}
              className="bg-[#264864] hover:bg-[#35a89d] text-white font-medium px-4 py-2 md:text-xs lg:text-sm rounded-md inline-flex items-center transition-colors duration-300"
            >
              Contact Us
              <svg className="ml-1 w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </button>
          </nav>

          {/* Mobile Hamburger */}
          <button
            className="md:hidden text-[#264864] hover:text-[#35a89d] p-2 rounded-md"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                d={mobileMenuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"}
              />
            </svg>
          </button>
        </div>
      </div>

      {/* Desktop Mega Menu */}
      {activeMenu?.submenu && (
        <div
          className="absolute left-0 right-0 top-full z-40"
          onMouseEnter={() => clearTimeout(timeout)}
          onMouseLeave={() => {
            timeout = setTimeout(() => setActiveMenu(null), 150);
          }}
        >
          <div className="mx-auto w-[60%] ml-auto py-10 px-10 bg-white shadow-2xl border-t border-gray-200 rounded-b-lg">
            {activeMenu.type === "categories" ? (
              <div className="grid grid-cols-5 gap-8">
                {activeMenu.submenu.map((section) => (
                  <div key={section.heading}>
                    <h4 className="text-[#264864] font-bold mb-3">{section.heading}</h4>
                    <ul className="space-y-2">
                      {section.items.map((item) => (
                        <li key={item} className="text-gray-700 hover:text-[#35a89d] cursor-pointer text-sm">
                          {item}
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            ) : (
              // Default submenu in 2 columns
              <div className="grid grid-cols-2 gap-8">
                {activeMenu.submenu.map((sub) => (
                  <Link key={sub.title} to={sub.path} className="text-left group/item">
                    <h4 className="text-[#264864] font-semibold mb-2 group-hover/item:text-[#35a89d] transition-colors duration-300">
                      {sub.title}
                    </h4>
                    <p className="text-sm text-gray-600 leading-snug">{sub.desc}</p>
                  </Link>
                ))}
              </div>
            )}
          </div>
        </div>
      )}

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-white shadow-lg border-t border-gray-200">
          <nav className="flex flex-col p-4">
            {navLinks.map((item) => (
              <div key={item.name} className="mb-2">
                <div className="flex justify-between items-center">
                  <Link
                    to={item.path}
                    className="text-[#264864] font-medium py-2 text-base"
                    onClick={() => { if (item.name === 'Case Studies') { sendEvent('view_case_studies_click'); } setMobileMenuOpen(false); }}
                  >
                    {item.name}
                  </Link>
                  {item.submenu && (
                    <button
                      className="text-[#264864] focus:outline-none"
                      onClick={() =>
                        setMobileSubMenuOpen(mobileSubMenuOpen === item.name ? null : item.name)
                      }
                    >
                      <svg
                        className={`w-4 h-4 transform transition-transform duration-200 ${
                          mobileSubMenuOpen === item.name ? "rotate-180" : ""
                        }`}
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                      </svg>
                    </button>
                  )}
                </div>
                {item.submenu && mobileSubMenuOpen === item.name && (
                  <div className="ml-4 mt-2 flex flex-col space-y-1">
                    {item.submenu.map((sub) => (
                      <Link
                        key={sub.title || sub.heading}
                        to={sub.path || "#"}
                        className="text-gray-700 py-1 pl-2 hover:text-[#35a89d]"
                        onClick={() => setMobileMenuOpen(false)}
                      >
                        {sub.title || sub.heading}
                      </Link>
                    ))}
                  </div>
                )}
              </div>
            ))}
            {/* Contact Button */}
            <button
              onClick={() => { sendEvent('contact_us_click', { source: 'header' }); setIsModalOpen(true); setMobileMenuOpen(false); }}
              className="bg-[#264864] hover:bg-[#35a89d] text-white font-medium py-2 px-4 rounded-md mt-4 text-center"
            >
              Contact Us
            </button>
          </nav>
        </div>
      )}

        {/* Floating WhatsApp Button */}
        <button 
            onClick={() => window.open('https://wa.me/+8801927046394', '_blank')} 
            className="fixed bottom-8 right-8 bg-[#25D366] hover:bg-[#128C7E] text-white w-16 h-16 rounded-full flex items-center justify-center shadow-lg transition-colors duration-300 z-50">
            <ChatIcon />
        </button>

      <ContactFormModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />

    </header>
  );
};

export default Header;